import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from "../assets/images/rabta logo.png";


const AdminLogin = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Check if admin is already logged in
    useEffect(() => {
        const adminData = localStorage.getItem('admin');
        if (adminData) {
            navigate('/admin/dashboard');
        }
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error for this field when user types
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email';
        }

        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);
        setErrors({});

        try {
            // Replace with your actual API endpoint
            const response = await fetch('YOUR_API_ENDPOINT/admin/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password
                })
            });

            const data = await response.json();

            if (response.ok) {
                // Store admin data in localStorage
                localStorage.setItem('admin', JSON.stringify(data));

                // Navigate to admin dashboard
                navigate('/admin/dashboard');
            } else {
                // Handle API errors
                setErrors({
                    submit: data.message || 'Invalid credentials. Please try again.'
                });
            }
        } catch (error) {
            setErrors({
                submit: 'An error occurred. Please try again later.'
            });
            console.error('Login error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="main-bg admin-login" style={{ width: "100%" }}>
            <div className="home-wrapper">
                <img src={Logo} alt="logo main" />
                <form onSubmit={handleFormSubmit} className="form-card">
                    <h2 className="form-title" style={{ marginBottom: 20, marginTop: 20, textAlign: 'center' }}>Admin Login</h2>

                    <input
                        type="email"
                        name="email"
                        placeholder="Email*"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="email"
                    />
                    {errors.email && <p className="error">{errors.email}</p>}

                    <input
                        type="password"
                        name="password"
                        placeholder="Password*"
                        value={formData.password}
                        onChange={handleChange}
                        autoComplete="current-password"
                    />
                    {errors.password && <p className="error">{errors.password}</p>}

                    {/* Show general API error if any */}
                    {errors.submit && <p className="error">{errors.submit}</p>}

                    <button
                        type="submit"
                        className="submit-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "LOGGING IN..." : "LOGIN"}
                    </button>
                    {/* 
                    <div className="forgot-password">
                        <a href="/admin/forgot-password">Forgot Password?</a>
                    </div> */}
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;